import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Quickdaytripdestinationmorachi() {



    const cardData =
    {
        keyword: 'Quick Day Trip Destinations Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Quick Day Trip Destinations Morachi Chincholi Pune',
        headingDescription: 'Set in 40 acres of lush green farmland, this agri-tourism center offers a full-day experience packed with traditional and modern activities. Enjoy bullock cart and tractor rides, horse riding, boating, swimming, rain dance, and village-style games. Cultural highlights like puppet and magic shows keep guests of all ages entertained. With delicious homemade Maharashtrian meals, a peaceful natural environment, and friendly staff, Anand Krushi Paryatan Kendra stands out as one of the best quick day trip destinations Morachi Chincholi Pune for anyone seeking a refreshing break close to the city.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi – Peacock Paradise",
    "description": "A scenic village known for over 2,000 free-roaming peacocks, peaceful farmlands, and a rich rural vibe. Watch peacocks dance, enjoy bullock cart rides, explore farm life, and indulge in local Maharashtrian meals. A perfect family retreat just 55 km from Pune."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "Located in Morachi Chincholi, this 40-acre agro-tourism farm offers tractor safaris, organic farming experiences, splash pools, pottery workshops, and unlimited thali lunches on banana leaves. Ideal for kids, parents, and even grandparents!"
  },
  {
    "title": "Hurda Party (Seasonal Experience)",
    "description": "From November to February, many farms in Morachi Chincholi host 'Hurda Parties' — where families can enjoy roasted green jowar served with chutneys, jaggery, and live folk music in open-air setups. A rustic winter delight!"
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "Just 25 km from Morachi Chincholi, this spiritual spot is one of the Ashtavinayak temples dedicated to Lord Ganesha. Combine spiritual peace with a rural day trip."
  },
  {
    "title": "Ghod River Backwaters",
    "description": "A calm and scenic location just a short drive from Morachi Chincholi. Great for a quick riverside picnic, birdwatching, and nature photography. Ideal for families looking for a quiet escape."
  },
  {
    "title": "Tulapur Historical Riverside",
    "description": "Visit the confluence of Bhima and Indrayani rivers, where Sambhaji Maharaj was martyred. A great educational trip for kids to learn about Maratha history and enjoy riverside views."
  },
  {
    "title": "Rural Games & Nature Trails",
    "description": "Let kids and adults enjoy traditional Indian games like kho-kho, lagori, sack race, and gilli-danda in open playgrounds. Many farms offer rope walks, bamboo swings, and shaded trails for birdwatching."
  },
  {
    "title": "Crafts & Pottery Workshop",
    "description": "At places like Anand Krushi, families can engage in pottery making, mud toy painting, and bamboo craft sessions. Take home a handmade souvenir and a smile!"
  },
  {
    "title": "Splash Pool & Rain Dance Zone",
    "description": "Cool off after rural adventures with a dip in the kids-friendly pool or groove under the rain dance zone with fun Marathi beats — a favorite for families on sunny weekends."
  },
  {
    "title": "Sunset Bonfire & Folk Music",
    "description": "Wrap up your day trip with a cozy bonfire, folk songs, dholki, and snacks under the stars — available at many agro-tourism spots on request. A lovely ending for family bonding."
  }
],




"services": [
  {
    "name": "Short and Easy Day Trips Near Morachi Chincholi",
    "description": "Looking for a quick escape from the city? Anand Krushi Paryatan Kendra offers easy-access day trips near Morachi Chincholi with nature, adventure, and cultural experiences all in one place—perfect for last-minute family plans or spontaneous outings."
  },
  {
    "name": "Quick Nature Getaways",
    "description": "Relax in the green surroundings of our farm with nature walks, birdwatching, and peaceful outdoor spaces—ideal for a few hours of calm and fresh air."
  },
  {
    "name": "Nearby Adventure Spots",
    "description": "Try short but exciting activities like rope climbing, tire bridges, and farm games. Fun for both kids and adults looking for a quick adrenaline rush."
  },
  {
    "name": "Family Quick Outing Places",
    "description": "Enjoy a short but joyful family outing with farm animal feeding, tractor rides, and kids' play areas. A great way to bond without traveling far."
  },
  {
    "name": "Scenic Day Trip Routes",
    "description": "Drive through scenic countryside roads to reach Anand Krushi Paryatan Kendra. The journey itself is refreshing, with beautiful rural views and greenery."
  },
  {
    "name": "Fast Picnic Spots",
    "description": "Pack light and enjoy a hassle-free picnic under trees, near the farm pond, or in shaded gazebos. Ideal for a peaceful afternoon with family or friends."
  },
  {
    "name": "Historical Quick Visits",
    "description": "Combine your farm visit with a short stop at nearby historic temples or forts. A touch of heritage adds depth to your day trip."
  },
  {
    "name": "Wildlife Quick Tours",
    "description": "Spot peacocks, birds, and other local animals during a short guided walk around the farm’s natural surroundings—perfect for curious young explorers."
  },
  {
    "name": "Budget-Friendly Short Trips",
    "description": "Anand Krushi Paryatan Kendra is an affordable getaway that includes entry, food, and fun activities—ideal for budget-conscious families or groups."
  },
  {
    "name": "Relaxing Day Trip Options",
    "description": "Just want to unwind? Enjoy a traditional meal, rest in hammocks, and soak in rural silence. A peaceful experience, even if you stay just a few hours."
  },
  {
    "name": "Cultural Quick Tours",
    "description": "See bullock carts, traditional tools, and local crafts in action. Quick cultural demos give visitors a taste of village life within a short timeframe."
  },
  {
    "name": "Farm Stay Quick Visits",
    "description": "Visit for just a few hours, but experience everything from farming to fresh food and local hospitality—without needing an overnight stay."
  },
  {
    "name": "Local Market Quick Stops",
    "description": "Grab organic farm produce, homemade snacks, and local crafts at the on-site market. A great add-on to your short visit."
  },
  {
    "name": "Weekend Quick Trips",
    "description": "Anand Krushi Paryatan Kendra is perfect for a half- or full-day trip on weekends—close enough for a morning drive and evening return."
  },
  {
    "name": "Photography Quick Spots",
    "description": "From peacocks to plowed fields, the farm offers scenic photo spots for quick photography sessions—great for reels, portraits, or nature shots."
  }
],
"tableData": [
  ["Short and Easy Day Trips Near Morachi Chincholi", "- Quick Nature Getaways"],
  ["Nearby Adventure Spots", "- Family Quick Outing Places"],
  ["Scenic Day Trip Routes", "- Fast Picnic Spots"],
  ["Historical Quick Visits", "- Wildlife Quick Tours"],
  ["Budget-Friendly Short Trips", "- Relaxing Day Trip Options"],
  ["Cultural Quick Tours", "- Farm Stay Quick Visits"],
  ["Local Market Quick Stops", "- Weekend Quick Trips"],
  ["Photography Quick Spots", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Morachi Chincholi Peacock Village",
    "WhyChoosedescription": "Just a short visit to witness thousands of peacocks in their natural habitat amidst ancient tamarind trees. Perfect for a quick wildlife experience close to Pune."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra",
    "WhyChoosedescription": "Experience rural farm life with easy access to tractor rides, animal interactions, and traditional Maharashtrian meals—ideal for a refreshing half-day outing."
  },
  {
    "WhyChooseheading": "Nighoj Potholes",
    "WhyChoosedescription": "A quick 25 km drive brings you to unique river-carved potholes—great for photography and a natural wonder to explore within a few hours."
  },
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "Explore local history and enjoy panoramic views from this nearby fort, suitable for a short cultural stop on your way back from Morachi Chincholi."
  },
  {
    "WhyChooseheading": "Vadgaon Dam",
    "WhyChoosedescription": "A peaceful dam surrounded by greenery, perfect for a brief picnic or a relaxing break amid nature."
  },
  {
    "WhyChooseheading": "Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "Visit this revered Ashtavinayak temple for a quick spiritual stop just 40 km away, enriching your day trip experience."
  }
]














    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What makes Morachi Chincholi a good quick day trip from Pune?',
    answer: 'Just 65 km from Pune, Morachi Chincholi offers serene rural scenery, natural peacock sightings, and hands-on farm experiences — all doable in a single day.',
  },
  {
    id: 'FAQ2',
    question: 'Which quick destinations can be combined with Morachi Chincholi?',
    answer: 'Nearby places include Ranjangaon Mahaganpati Temple, Alandi, Shikrapur, and agro-tourism centers like Anand Krushi Paryatan Kendra.',
  },
  {
    id: 'FAQ3',
    question: 'What are the top attractions within Morachi Chincholi?',
    answer: 'Top attractions include the peacock sanctuary, bullock cart rides, butterfly gardens, nature walks, and traditional Maharashtrian meals.',
  },
  {
    id: 'FAQ4',
    question: 'How long does it take to reach Morachi Chincholi from Pune?',
    answer: 'It takes approximately 1.5 to 2 hours by car, making it ideal for a quick and spontaneous day trip.',
  },
  {
    id: 'FAQ5',
    question: 'Are the activities suitable for all age groups?',
    answer: 'Yes. Families with kids, senior citizens, and young travelers can all enjoy the rural charm, animal interactions, and slow-paced vibe.',
  },
  {
    id: 'FAQ6',
    question: 'Is there any entry fee or ticket system?',
    answer: 'There’s no entry fee to the village, but agro-tourism centers like Anand Krushi may charge a small fee for meals and activities.',
  },
  {
    id: 'FAQ7',
    question: 'Can we complete this trip and return to Pune the same day?',
    answer: 'Yes, it’s perfect for a same-day return with plenty of time to relax, eat, explore, and head back comfortably by evening.',
  },
  {
    id: 'FAQ8',
    question: 'What’s the best time of day to visit Morachi Chincholi?',
    answer: 'Mornings (7–10 AM) are best for spotting peacocks. Late afternoons are also pleasant for farm visits and traditional meals.',
  },
  {
    id: 'FAQ9',
    question: 'Is the road to Morachi Chincholi safe for a quick drive?',
    answer: 'Yes. Roads via Alandi or Chakan are well-connected and suitable for cars, bikes, and tempo travelers.',
  },
  {
    id: 'FAQ10',
    question: 'Can we get local food there during the day?',
    answer: 'Absolutely! Farm-fresh Maharashtrian thalis are served at agro-tourism centers like Anand Krushi — ideal for lunch or late brunch.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Bhagat, Pune',
    feedback: "We left Pune in the morning, reached Morachi Chincholi in 90 minutes, and spent a beautiful day surrounded by peacocks and farms. Quick, fun, and refreshing!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Tamhane, Hinjewadi',
    feedback: "Perfect day trip destination near Pune! We explored the farms, had a peaceful lunch, and even spotted a group of peacocks. Great for family or couples!",
    rating: 5,
  },
];

















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Quick Day Trip Destinations Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/quick-day-trip-morachi-chincholi.jpg",
  "description": "Find quick and refreshing day trip destinations near Morachi Chincholi, Pune. Perfect for families and nature lovers—enjoy scenic spots, wildlife tours, picnic areas, cultural visits, and farm stays all within a short drive.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "580",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/quick-day-trip-destinations"
  }
};




    return (
        <div>
<Helmet>
  <title>Quick Day Trip Destinations Morachi Chincholi Pune | Short Nature Getaways & Family Outings</title>
  <meta 
    name="description" 
    content="Explore short and quick day trip destinations near Morachi Chincholi Pune including nature getaways, picnic spots, cultural visits, wildlife tours, and farm experiences. Ideal for families, couples, and weekend escapes." 
  />
  <meta 
    name="keywords" 
    content="Short and easy day trips near Morachi Chincholi, Quick nature getaways, Nearby adventure spots, Family quick outing places, Scenic day trip routes, Fast picnic spots, Historical quick visits, Wildlife quick tours, Budget-friendly short trips, Relaxing day trip options, Cultural quick tours, Farm stay quick visits, Local market quick stops, Weekend quick trips, Photography quick spots" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Quickdaytripdestinationmorachi;